import { Firebase } from './app';
import 'firebase/functions';

export default Firebase.functions();
